import {Validate} from '../global/_formValidation';
import {getURLParamValue} from '../global/_getURLParamValue';

const findColorInCollection = (currentArea, color) => {
  var collectionForTheColor = {},
  collectionsContainer = $(currentArea).find('.collection-list');
  if (collectionsContainer.length > 0) {
    var collectionsJson = collectionsContainer.data('json');
    if (collectionsJson) {
      $.each(collectionsJson, function() {
        if (color.toLowerCase() === this.color.toLowerCase() || this.color === "groupTag") {
          collectionForTheColor = this;
          return false;
        }
      });
    }
  }
  return collectionForTheColor;
};

const getColor = (currentArea) => {
  //TODO: test alt hover from nav setting an xxx__zi image in DI par`ameter
  var $currentArea = $(currentArea),
  color = ''; //if no color attribute, use empty string as color
  //if there is only one option
  if ($currentArea.find('.color-select-group .one-option').length > 0) {
    color = $currentArea.find('.color-select-group .one-option').text();
    //if there are multiple colors, the page loads with none selected
    //so try and match the current image up to a data-fullimage in the options
  } else if ($currentArea.find('.color-select-group').length > 0) {
	var colorSelectBox = $currentArea.find('.color-select-group').find('select');
	if(colorSelectBox.length > 0 && colorSelectBox.val() != ''){
		return colorSelectBox.find('option[value="' + colorSelectBox.val() + '"]').data('attrvalue');
	}
    var image = $currentArea.find('img.mainImage,img.componentImage');
    if (image.length > 0) {
      var imageSplit = image.attr('src').split('/'),
      imageName = imageSplit[imageSplit.length - 1].split('.jpg')[0];
      $.each($currentArea.find('.color-select-group option'), function(optionNum, option) {
        if ($(option).data('fullimage') == imageName) {
          color = $(option).data('attrvalue');
          return false;
        }
      });
    }
  }
  return color;
};

export const initCollections = () => {

  if ($('.collection-list').length > 0) {
    if ($('.product-grouping-display-page').length > 0) {
      var currentArea = $('.product-grouping-display-page');
      populateData(currentArea);
    } else if ($('.bundle-display-page').length > 0) {
      $.each($('article.sto_item'), function(itemNum, currentArea) {
        var currentArea = $(currentArea);
        populateData(currentArea);
      });
    }
  }
};

const buildCollectionArea = (currentArea, collectionToBuild) => {
  var html = '';
  if (collectionToBuild.details && collectionToBuild.details.length > 0) {
	var pageType = (collectionToBuild.color === "groupTag") ? "PP-QV-GT" : "PP-QV-SC";
    for (var i = 0; i < collectionToBuild.details.length; i++) {
      var detail = collectionToBuild.details[i],
      urlName = detail.name.replace(/\s+/g, '-').split('"').join('').split('&').join('').split('?').join('').split('/').join('').split('#double;').join('').split('#').join('').toLowerCase();
      html += `<li class="collection-item">
      <a href="javascript:void(0)" id="qv-${detail.catentryId}" data-modal-title="${detail.name}" data-toggle="modal" data-target=".modal-quickview" data-modal-body="callQuickView({&quot;catentryId&quot;: &quot;${detail.catentryId}&quot;, &quot;categoryId&quot;: &quot;&quot;, &quot;collection&quot;: &quot;true&quot;, &quot;collectionArea&quot;: &quot;${currentArea.prop('id')}&quot;, &quot;color&quot;: &quot;${detail.color}&quot;})">
      	<img data-pagetype=` + pageType + ` src="//dimg.dillards.com/is/image/DillardsZoom/productRec/${urlName}/${detail.imageName}.jpg" data-catentryid="${detail.catentryId}" data-color="${detail.color}" alt="${detail.name}">
      	<div class="collection-item-name"><p>${detail.name}</p></div>
      </a>
      </li>`;
    }

  }
  var collectionsContainer = $(currentArea).find('.collection-list');
  if((collectionToBuild.color || '') != collectionsContainer.data('color')){
	  collectionsContainer.removeClass('slick-initialized slick-slider').html(html);
	  //stop the blink if selecting same color
	  collectionsContainer.data('color', collectionToBuild.color || '');
	  if (html != '') {
	    setTimeout(function() {
	      if (collectionsContainer.find('.collection-item').length > 0) {
          if ($('#add-to-bag-rec').length > 0 || $('#add-to-registry-rec').length > 0) {
              var next = '<i data-twist="add-to-modal-right" class="fa fa-angle-right slickCustomNext" aria-hidden="true"></i>',
                  prev = '<i data-twist="add-to-modal-left" class="fa fa-angle-left slickCustomPrev" aria-hidden="true"></i>',
                  slides_desktop = 4,
                  slides_mobile = 2;
          } else {
            var next = '<i class="fa fa-angle-right slickCustomNext" aria-hidden="true"></i>',
                prev = '<i class="fa fa-angle-left slickCustomPrev" aria-hidden="true"></i>';

            if ($('.sto_item .collection-item').length > 0) {
              var slides_desktop = 3,
                  slides_mobile = 3;
            } else {
              var slides_desktop = 6,
                  slides_mobile = 3;
            }
          }
	    	  collectionsContainer.not('.slick-initialized').slick({
              draggable: false,
              infinite: false,
              nextArrow: next,
              prevArrow: prev,
              slidesToShow: slides_desktop,
              slidesToScroll: 1,
              responsive: [{
                  breakpoint: 1025,
                  settings: {
                      arrows: false,
                      slidesToShow: 4,
                      swipe: true,
                      swipeToSlide: true
                  }
              }, {
                  breakpoint: 768,
                  settings: {
                      arrows: false,
                      slidesToShow: slides_mobile,
                      swipe: true,
                      swipeToSlide: true
                  }
              }]
          });

	        collectionsContainer.parent().show();
	        collectionsContainer.parent().parent().show();
	      }
	      $(".collection-list").trigger('resize')
	    }, 0);
	  }else{
		  collectionsContainer.parent().hide();
	      collectionsContainer.parent().parent().hide();
	  }
  }
};

const populateData = (currentArea) => {
  var catentryId = $(currentArea).find('form[id^="OrderItemAdd_"] input[name="catEntryId"]').val();
  if (catentryId) {
    var dataString = `storeId=301&catalogId=301&langId=-1&catentryId=${catentryId}`,
    forceDatabase = getURLParamValue("forceDatabase");
    if (forceDatabase != '')
    dataString += `&forceDatabase=${forceDatabase}`;
    $.ajax({
      url: "/webapp/wcs/stores/servlet/CollectionsView",
      cache: true,
      type: "GET",
      dataType: "json",
      data: dataString,
      success: function(json) {
        $(currentArea).find('.collection-list').data('json', json);
        if($(currentArea).find('.color-select').length > 0){
        	$(currentArea).find('.color-select').on('change.collections', function(){
        		var color = getColor(currentArea);
                var collectionToAdd = findColorInCollection(currentArea, color);
                buildCollectionArea(currentArea, collectionToAdd);
        	});
        }
        var color = getColor(currentArea);
        var collectionToAdd = findColorInCollection(currentArea, color);
        buildCollectionArea(currentArea, collectionToAdd);
      },
      error: function(jqXHR, exception) {
        var msg = '';
        if (jqXHR.status === 0)
        msg = 'Not connect.\n Verify Network.';
        else if (jqXHR.status == 404)
        msg = 'Requested page not found. [404]';
        else if (jqXHR.status == 500)
        msg = 'Internal Server Error [500].';
        else if (exception === 'parsererror')
        msg = 'Requested JSON parse failed.';
        else if (exception === 'timeout')
        msg = 'Time out error.';
        else if (exception === 'abort')
        msg = 'Ajax request aborted.';
        else
        msg = 'Uncaught Error.\n' + jqXHR.responseText;
        return msg;
      }
    });
  }
};
